import { InlineStatusDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
import { helper } from '@ember/component/helper';
function getMarketInlineStatus([inlineStatusStyle]) {
  switch (inlineStatusStyle) {
    case InlineStatusDescription.InlineStatusStyle.INLINE_STATUS_STYLE_SUCCESS:
      return 'success';
    case InlineStatusDescription.InlineStatusStyle.INLINE_STATUS_STYLE_WARNING:
      return 'warning';
    case InlineStatusDescription.InlineStatusStyle.INLINE_STATUS_STYLE_ERROR:
      return 'error';
    default:
      return 'info';
  }
}
export default helper(getMarketInlineStatus);